import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { debounce } from 'lodash';
import { fetchAdminUser, postAddadminUser } from 'redux/actions/AdminUserAction';
import { fetchSupplierRole } from 'redux/actions/RolesAndPermissionsAction';
import { postAddVendor } from 'redux/actions/UserVendor';
import BackDrop from 'components/backDrop/BackDrop';
import CommonTable from 'components/commonTable/CommonTable';
import CommonButtonSubHeader from 'components/commonButtonSubHeader/CommonButtonSubHeader';
import useModal from 'hooks/useModal';
import CommonDialog from 'components/commonDialog/CommonDialog';
import {regionalUserDialogData,} from 'pages/vendor/VendorBreadCrumbData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function RegionalManagerView() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState('');
  const { open, toggle } = useModal();
  const id = localStorage.getItem('ID');

  const adminDetails = useSelector((state) => state?.getAdminUser?.adminUser);

  const loader = useSelector((state) => state?.getAdminUser?.loading);
  const supplierRole = useSelector((state) => state?.getSupplierRole?.roles);

  const roleOption =
    supplierRole?.length > 0 &&
    supplierRole?.map((val, idx) => {
      return { value: val?.role, label: val?.roleName };
    });

    const defaultValues = {
      name:''
    }

  const role = {
    role: 3,
    businessType:0,
  };

  let filterData = {
    page: page,
    pageSize: rowsPerPage,
    search: search,
  };

  useEffect(() => {
    dispatch(fetchAdminUser(filterData));
    dispatch(fetchSupplierRole(role));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(fetchAdminUser({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      fetchAdminUser({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  //Search
  const onSearch = debounce((e) => {
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
    };
    dispatch(fetchAdminUser(searchFilterData));
  }, 1000);

  // Add driver
  const onDialog = (val, code) => {
    const data = {
      mobile: val.number,
      firstName: val?.vendorName.trim(),
      lastName: '',
      email: val.email,
      countryCode: code,
      companyName: val?.vendorName.trim(),
      id: id,
      role: val?.role,
      roleType: 3,
      type:'regional'
    };
    dispatch(postAddVendor(data));
    toggle();
  };

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const regionalmanagerRoleEnum = roleAndPermissionEnum.regionalmanager

  const accessForall = handlePermissions(roleAndPermissions, regionalmanagerRoleEnum.moduleKey, {defaultAllAccess: regionalmanagerRoleEnum.all, customAccess: regionalmanagerRoleEnum.add});

  const accessForOnlyView = handlePermissions(roleAndPermissions, regionalmanagerRoleEnum.moduleKey, {customAccess: regionalmanagerRoleEnum.view});

  const accessForAdd = handlePermissions(roleAndPermissions, regionalmanagerRoleEnum.moduleKey, {customAccess: regionalmanagerRoleEnum.add});

  const addAccess = (accessForall||accessForAdd)

  return (
    <div>
      <Box className="driverContainer">
        <CommonButtonSubHeader
          btnName={ addAccess && 'User'}
          btnAction={toggle}
          tabName={'company'}
          search={search}
          height={true}
          onSearchQuery={onSearch}
          filter={false}
        />
        {loader ? (
          <Box>
            <BackDrop />
          </Box>
        ) : (
          <CommonTable
            data={adminDetails}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        )}

        <CommonDialog
          className="mb20"
          open={open}
          handleClose={toggle}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'Create'}
          type={'User'}
          formData={regionalUserDialogData(roleOption)}
          defaultValues={defaultValues}
        />
      </Box>
    </div>
  );
}

export default RegionalManagerView;

